import React, { useEffect, useState } from 'react';
import {
	Buttonwrapper,
	EmailResp,
	Label,
	Line,
	MailContainer,
	StyledTable,
	Textarea,
	Value,
	ValueWrapper,
} from './SendMail.style';
import { ApButtonSecondary } from '@alixpartners/ui-components';
// import { getWorkshopName } from 'utils/apiRequests';
import MultiSelect from '../MultiSelect';
import { getWorkshopName, sendMailtoSpendOwners } from 'utils/apiRequests';
import { LINK_TYPES } from '../utils';

const SendMail = props => {
	const [sendMail, setSendMail] = useState({
		id: '',
		message: '',
	});
	const [mailResponse, setMailResponse] = useState('');
	const [workshopGroup, setWorkshopGroup] = useState({
		options: [],
		selectedOption: [],
	});

	const [loading, setLoading] = useState(false);
	const { location } = props;

	useEffect(() => {
		setLoading(true);
		getWorkshopName().then(response => {
			const optionsResponse = response.data.map(option => ({
				label: option.workshop_Name,
				value: option.workshop_Name,
			}));
			const singleOptionSelection =
				optionsResponse.length === 1 ? [optionsResponse[0].label] : [];
			setWorkshopGroup(prevState => ({
				...prevState,
				options: optionsResponse,
				selectedOption: singleOptionSelection,
			}));
		});
		setLoading(false);
	}, []);

	const handleChange = (change, changeContent) => {
		if (change === 'ownerId') {
			setSendMail(prevState => ({
				...prevState,
				id: changeContent,
			}));
		} else {
			setSendMail(prevState => ({ ...prevState, message: changeContent }));
		}
	};

	const onFilterChangeHandler = value => {
		setWorkshopGroup(prevState => ({
			...prevState,
			selectedOption: value,
		}));
	};

	const handleEmailSend = (loc, credentials) => {
		const link = loc.pathname.split('/');

		const payload = {
			type: 0,
			message: credentials.message,
			linkNumber: LINK_TYPES[link[2]].toString(),
			workshopName: workshopGroup.selectedOption,
		};

		sendMailtoSpendOwners(payload).then(response => {
			setSendMail({
				id: '',
				message: '',
			});
			setWorkshopGroup(prevState => ({
				...prevState,
				selectedOption: [],
			}));
			if (response.succeeded) {
				setMailResponse('Email sent successfully');
			} else {
				setMailResponse('Error occured.Try Again');
			}
			setTimeout(
				() => {
					setMailResponse('');
				},
				[4000]
			);
		});
	};

	return (
		<MailContainer>
			<StyledTable>
				<Line>
					<Label>Email</Label>
					<Value>
						<ValueWrapper>
							<MultiSelect
								name="workshop_group"
								label="Workshop Group"
								options={workshopGroup.options}
								selected={workshopGroup.selectedOption}
								isLoading={loading}
								onChange={v => {
									onFilterChangeHandler(v);
								}}
							/>
						</ValueWrapper>
					</Value>
				</Line>
				<Line>
					<Label>Message</Label>
					<Value>
						<>
							<Textarea
								rows={5}
								value={sendMail.message}
								onChange={event =>
									handleChange('ownerMessage', event.target.value)
								}
							/>
						</>
					</Value>
				</Line>
			</StyledTable>
			<Buttonwrapper>
				<ApButtonSecondary
					onClick={() => handleEmailSend(location, sendMail)}
					disabled={
						workshopGroup.selectedOption.length === 0 || sendMail.message === ''
					}
				>
					Send Email
				</ApButtonSecondary>
				<EmailResp>{mailResponse}</EmailResp>
			</Buttonwrapper>
		</MailContainer>
	);
};

export default SendMail;
